import React from "react";
import { Button, Grid, Typography } from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import CloseIcon from "@material-ui/icons/Close";

import "./style.css";
import FilePreview from "./templates";
import { FileUploaderDomain } from "./domain";

const FileUploader = ({ uploadedFile, setUploadedFile }) => {
  const [fileUploadError, setFileUploadError] = React.useState(false);
  const fileInputRef = React.useRef(null);

  const previewUrl = React.useMemo(() => {
    if (!(uploadedFile && uploadedFile instanceof Blob)) return null;
    return URL.createObjectURL(uploadedFile);
  }, [uploadedFile]);

  React.useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  const onClickUploadArea = (event) => {
    setFileUploadError(false);
    event.stopPropagation();
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileUpload = (event) => {
    const file = event?.target?.files[0];
    FileUploaderDomain.validateAndSetFile({
      file,
      setFileUploadError,
      setUploadedFile,
    });
  };

  const onFileDrop = (event) => {
    event.preventDefault();
    const file = event?.dataTransfer?.files[0];
    FileUploaderDomain.validateAndSetFile({
      file,
      setFileUploadError,
      setUploadedFile,
    });
  };

  const handleRemoveFile = () => {
    setUploadedFile(null);
  };

  const onCloseError = (event) => {
    event.stopPropagation();
    setFileUploadError(false);
  };

  return (
    <Grid
      container
      direction="column"
      className="file-uploader"
      onDragOver={(event) => event.preventDefault()}
      onDrop={onFileDrop}
      onClick={onClickUploadArea}
    >
      {uploadedFile ? (
        <Grid container className="file-view">
          <FilePreview
            uploadedFile={uploadedFile}
            handleRemoveFile={handleRemoveFile}
            previewUrl={previewUrl}
          />
        </Grid>
      ) : (
        <>
          <Grid item container direction="column" className="upload-section">
            <CloudUploadIcon />
            <Typography variant="body2" style={{ color: "#000000" }}>
              Drag and drop to upload your file
            </Typography>
            <Typography variant="body2" style={{ color: "#000000" }}>
              or
            </Typography>
            <Button
              variant="contained"
              className="primary-button"
              onClick={onClickUploadArea}
            >
              Browse Files
            </Button>

            <input
              type="file"
              ref={fileInputRef}
              accept="application/pdf,image/png,image/jpeg"
              onChange={handleFileUpload}
              style={{ display: "none" }}
            />
          </Grid>
          {fileUploadError && (
            <Grid
              item
              container
              direction="row"
              wrap="nowrap"
              className="upload-error"
            >
              <ErrorOutlineIcon />
              <Typography variant="caption" className="text">
                The selected file type is not supported. Please upload a file in
                JPEG, PNG, or PDF format.
              </Typography>
              <CloseIcon onClick={onCloseError} className="close-icon" />
            </Grid>
          )}
        </>
      )}
    </Grid>
  );
};

export default FileUploader;
